import React, { useEffect, useState } from "react";
import { assets } from "../assets/assets";
import QRCodeGenerator from "./QrCode";

interface WhatsAppButtonProps {
    showQr?: boolean;
    showPhone?: boolean;
    connectionId: string;
    doctorName: string;
    doctorId: string;
}

interface WhatsAppCardProps {
    connectionId: string;
    doctorName: string;
    doctorId: string;
}

interface WhatsappWrapperProps {
    isMobile: boolean;
    children: React.ReactNode;
    link?: string;
    whatsappLink: string;
}

const phoneNumber = (import.meta as any).env.VITE_WHATSAPP_NUMBER;

const frontendBaseUrl = window.location.origin;
const baseWhatsappLink = `https://wa.me/${phoneNumber.slice(1)}`;

const Wrapper: React.FC<WhatsappWrapperProps> = ({ children, isMobile, whatsappLink }) => {
    const className =
        "flex flex-col w-full items-center gap-4 p-6 border border-green-300 rounded-xl bg-white hover:shadow-md transition duration-300 hover:border-green-400";

    return isMobile ? (
        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="">
            {children}
        </a>
    ) : (
        <div className={className}>{children}</div>
    );
};
const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ showQr, showPhone, connectionId, doctorName, doctorId }) => {
    const [id, setId] = useState(connectionId);
    const [doctorid, setDoctorId] = useState(doctorId);
    const [name, setName] = useState(doctorName);

    useEffect(() => {
        connectionId && setId(connectionId);
    }, [connectionId]);

    useEffect(() => {
        doctorName && setName(doctorName);
    }, [doctorName]);

    useEffect(() => {
        doctorId && setDoctorId(doctorId);
    }, [doctorId]);

    console.log("Name", name);

    // Preparing Whatsapp link
    const connectPart = `connect: ${id}`;
    const messagePart = `Hello Dr.${name}, I would like to connect with you.`;

    const redirectLink = `${frontendBaseUrl}/redirect?doctorId=${doctorid}&url=${encodeURIComponent(
        baseWhatsappLink
    )}?text=${encodeURIComponent(`${connectPart} \n${messagePart}`)}`;
    return (
        <Wrapper isMobile={!showQr && !showPhone} whatsappLink={redirectLink}>
            <div
                className={`
                    flex items-center justify-center md:items-start gap-3
                    ${
                        !showQr && !showPhone
                            ? "bg-green-600 hover:bg-green-700 transition text-white rounded-lg px-4 py-3 cursor-pointer shadow-md"
                            : ""
                    }
                `}
                style={{
                    minHeight: !showQr && !showPhone ? "48px" : undefined
                }}
            >
                <div className="flex items-center justify-center">
                    <img src={assets.whatsapp_icon} alt="WhatsApp" className="w-8 h-8 md:w-14 md:h-14" />
                </div>
                <div className="flex flex-col">
                    <p
                        className={`font-bold ${
                            !showQr && !showPhone ? "text-white" : "text-neutral-800"
                        } text-base md:text-lg`}
                    >
                        Book Appointment via WhatsApp
                    </p>
                    <p className="hidden md:block text-neutral-600 text-sm">Quick & easy scheduling</p>
                </div>
            </div>
            {showQr && (
                <div className="flex flex-col items-center gap-3 p-2 bg-gray-50 rounded-lg w-full mt-2">
                    <p className="text-sm font-medium text-gray-600">Scan QR code</p>
                    <QRCodeGenerator url={redirectLink} />
                </div>
            )}
        </Wrapper>
    );
};

const WhatsAppCard: React.FC<WhatsAppCardProps> = ({ connectionId, doctorName }) => {
    const [id, setId] = useState(connectionId);
    const [name, setName] = useState(doctorName);

    useEffect(() => {
        setId(connectionId);
    }, [connectionId]);

    useEffect(() => {
        setName(doctorName);
    }, [doctorName]);

    // Preparing Whatsapp link
    const connectPart = `connect: ${id}`;
    const messagePart = `Hello Dr.${name}, I would like to connect with you.`;
    const redirectLink = `${frontendBaseUrl}/redirect?url=${encodeURIComponent(
        baseWhatsappLink
    )}?text=${encodeURIComponent(`${connectPart} \n${messagePart}`)}`;

    console.log(id);

    return (
        <div className="flex flex-col gap-8 justify-center items-center px-8 py-8 max-w-md mx-auto">
            <div className="text-2xl line-clamp-2 w-full text-center font-semibold text-gray-800">
                Book Appointment via WhatsApp
            </div>

            <div className="flex flex-col items-center px-8 py-8 border border-green-200 gap-4 rounded-lg shadow-md bg-white text-center w-full">
                <div className="relative -top-2 transform hover:scale-105 transition duration-300">
                    <img src={assets.whatsapp_icon} alt="WhatsApp" className="w-24 h-24" />
                </div>

                <div className="w-full">
                    <p className="text-gray-600 font-semibold text-base">Click to book your appointment</p>
                </div>

                <a
                    href={redirectLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-600 text-white px-6 py-3 rounded-md text-sm font-medium shadow-md hover:bg-green-700 transition w-full flex items-center justify-center gap-2"
                >
                    <span>Open WhatsApp</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                </a>

                <p className="text-xs text-gray-500 mt-2">Or message us at {phoneNumber}</p>
            </div>
        </div>
    );
};

export { WhatsAppButton, WhatsAppCard };
